import utils from '../utils'
import { setSessionStorage,getSessionStorage } from '../utils/auth.js'

// DES 加/解密 key (8 位)
const DES_KEY = 'Easyway!'

let global = window || {};

var ZJUser = function () {
    this.UserId = ''
    this.LoginName = ''
    this.UserName = ''
    this.DisplayName = ''
    this.token = ''
    this.userInfo = {}
}

var pt = ZJUser.prototype

// 构建 Token
function _genToken(user, password) {
    if (!user || !password)
        return ''
    let timestamp = (new Date()).getTime().toString()
    let s =
        (user.UserId || '') + '|' +
        (user.LoginName || '') + '|' +
        utils.md5(DES_KEY + timestamp + utils.md5(password || '')) + '|' +
        timestamp + '|' +
        timestamp + '|'
    return s
}

function _parseToken(token) {
    let arr = (token || '').split('|')
    if (arr.length < 5) {
        return {
            UserId: '',
            LoginName: '',
            password: '',
            loginTime: 0,
            accessTime: 0
        }
    }
    return {
        UserId: arr[0],
        LoginName: arr[1],
        password: arr[2],
        loginTime: parseInt(arr[3]) || 0,
        accessTime: parseInt(arr[4]) || 0
    }
}

function _buildFormatedToken(token) {
    let s =
        (token.UserId || '') + '|' +
        (token.LoginName || '') + '|' +
        (token.password || '') + '|' +
        (token.loginTime || '') + '|' +
        (token.accessTime || '') + '|'
    return s
}

// 检查 Token
function _checkToken(user, token) {
    if (!user || !token)
        return false
    let t = _parseToken(token)
    return t.UserId == user.UserId &&
        t.LoginName == user.LoginName
}

// 获取消息通知的认证 Token
pt.getNotifyToken = function () {
    return this.token ? encrypt(this.token) : '';
};

pt.genToken = function (password) {
    this.token = getSessionStorage("accessToken")||_genToken(this, password) || ''
    return this.token
}

pt.getFormatedToken = function () {
    return _parseToken(this.token)
}

pt.extend = function () {
    return utils.extend.apply(this, [this, ...arguments])
}

pt.setUser = function (user, password) {
    user = user || {}
    this.extend(user)
    this.DisplayName = this.UserName || this.LoginName || '';
    if (user.data?.accessToken) {
        this.token = user.data.accessToken
        console.log(user.data.accessToken)
        sessionStorage.setItem("accessToken", user.data.accessToken)
        // setSessionStorage("accessToken",user.data.accessToken);
        // setSessionStorage("accessToken",user.data.accessToken);
        console.log(222)
    }
    else if (password) {
        this.genToken(password)
    }
    this.userInfo = user
    this.saveToCookie()
}

pt.logout = function () {
    this.clearCookie();
    this.UserId = ''
    this.LoginName = ''
    this.UserName = ''
    this.DisplayName = ''
    this.token = ''
    this.userInfo = {}
    localStorage.setItem("action", "logout");
};

// 判断是否已经登录
pt.isLogin = function () {
    return !!this.UserId && !!this.getCookie('Admin-Token')
}

let encrypt = function (msg) {
    if (!msg) return '';
    // 转换为 UTF-8 字节数组
    let utf8Array = utils.stringToUtf8ByteArray(msg);

    // 拼接 UTF-8 字节数组为字符串
    let newMsg = '';
    for (let i = 0; i < utf8Array.length; i++) {
        newMsg += String.fromCharCode(utf8Array[i]);
    }

    // 加密拼接后的字符串
    let s = utils.crypto.encrypt(newMsg);
    return utils.crypto.encrypt(s, DES_KEY);
}

let decrypt = function (text) {
    if (!text) return '';
    try {
        // 解密
        let s = utils.crypto.decrypt(text, DES_KEY);
        s = utils.crypto.decrypt(s);

        // 转换为 UTF-8 字节数组
        let utf8Array = [];
        for (let i = 0; i < s.length; i++) {
            utf8Array[i] = s.charCodeAt(i);
        }

        // 解码 UTF-8 字节数组为字符串
        return utils.utf8ByteArrayToString(utf8Array);
    }
    catch (e) {
        return '';
    }
}

//获取最后一次登录的账号
pt.getLastLoginName = function () {
    if (this.LoginName) {
        return this.LoginName;
    }
    else {
        let val = this.getCookie('ln');
        let loginName = val ? decrypt(val) : '';
        return loginName;
    }
};

// 保存登录信息到 cookie
pt.saveToCookie = function () {
    this.setCookie('tk', this.token ? encrypt(this.token) : '')
    this.setCookie('uid', this.UserId ? encrypt(this.UserId) : '')
    this.setCookie('ln', this.LoginName ? encrypt(this.LoginName) : '')
    this.setCookie('un', this.UserName ? encrypt(this.UserName) : '')
    localStorage.setItem("user", this.userInfo ? encrypt(JSON.stringify(this.userInfo)) : '');
}

// 清空 cookie 中的登录信息
pt.clearCookie = function () {
    this.delCookie('tk')
    this.delCookie('uid')
    //this.delCookie('ln')
    this.delCookie('un')
    this.delCookie('Admin-Token')
    localStorage.removeItem("user")
}

// 从 cookie 还原登录信息
pt.restoreFromCookie = function () {

    //区分统一登录时，切换子系统时清除缓存
    if (
        this.isLogin && !utils.getQueryString("token") && (utils.getQueryString("userName") != undefined &&
            utils.getQueryString("userName") != "" &&
            utils.getQueryString("userName") != null)

    ) {
        this.clearCookie();
        return;
    }

    let user = {}
    if (utils.getQueryString("token") && utils.getQueryString("userId") && utils.getQueryString("userName")) {
        this.setCookie('Admin-Token', utils.getQueryString("token"));
        user.UserId = utils.getQueryString("userId");
        user.LoginName = utils.getQueryString("userName");
        this.setCookie('tk', encrypt(_genToken(user, "token")))
        this.setCookie('uid', encrypt(utils.getQueryString("userId")))
        this.setCookie('ln', encrypt(utils.getQueryString("userName")))
        this.setCookie('un', encrypt(utils.getQueryString("userName")))
    }

    // console.log("localStorage.getItem()")
    // console.log(localStorage.getItem("user"))
    let val;
    val = localStorage.getItem("user")
    // console.log(val)
    const userInfo = val ? decrypt(val) : ''
    if (userInfo != '') {
        user.userInfo = JSON.parse(userInfo);
    }


     val = this.getCookie('tk')
    user.token = val ? decrypt(val) : ''

    val = this.getCookie('uid')
    user.UserId = val ? decrypt(val) : ''

    val = this.getCookie('un')
    user.UserName = val ? decrypt(val) : ''

    val = this.getCookie('ln')
    user.LoginName = val ? decrypt(val) : ''


    let valid = _checkToken(user, user.token)
    if (valid) {
        // 刷新下 Token
        let t = _parseToken(user.token)
        t.accessTime = (new Date()).getTime()
        user.token = _buildFormatedToken(t)
        this.setUser(user)
    }
    else {
        this.setUser({ LoginName: user.LoginName })
    }
}

pt.setCookie = function (cname, cvalue, exdays, path) {
    utils.cookie.setCookie(cname, cvalue, exdays, path)
}

pt.getCookie = function (cname) {
    return utils.cookie.getCookie(cname)
}

pt.delCookie = function (cname) {
    utils.cookie.delCookie(cname)
}

ZJUser.install = function (Vue) {
    // 切换为响应式扩展
    ZJUser.prototype.extend = function () {
        return Vue.reactiveExtend.apply(this, [this, ...arguments])
    }

    ZJUser.current = new ZJUser();
    ZJUser.current.restoreFromCookie();
    global.$user = global.ZJApp.user = ZJUser.current;

    // 混入用户
    Vue.mixin({
        data() {
            return {
                zj_user: ZJUser.current
            }
        },
        computed: {
            isLogin() { return ZJUser.current.isLogin() }
        }
    });

    Vue.prototype.user = ZJUser.current;

}

export default ZJUser